import { c as _c } from "react/compiler-runtime";
// The one loader: a thin indeterminate line (book.css `.loader`) for content that has nothing to show yet. Pages and
// groups get the same line from `aria-busy` (BookPage / Group `busy`); this is for anything else (panel content).
export function Loader(t0) {
  const $ = _c(2);
  const {
    on
  } = t0;
  let t1;
  if ($[0] !== on) {
    t1 = on ? <div className="loader" role="progressbar" aria-busy="true" /> : null;
    $[0] = on;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}